/**
 * The loading state, matching the LOADING_SPINNER markup in public/index.html.
 * `inline` drops the 60px padding for use inside an already-small box.
 */
export default function Spinner({ inline = false, label }) {
  if (inline) return <span className="spinner" aria-label={label ?? 'Loading'} />;
  return (
    <div className="loading">
      <div className="spinner" />
      {label && <div className="spinner-label">{label}</div>}
    </div>
  );
}
